import i18n from "i18next";
import { CustomerOrderProfitabilityLineKey } from "src/api/generated/erp/sales/customerOrder/profitability/model/customerOrderProfitabilityLineKey.ts";
import { formatMoneyWithCurrency } from "src/utils/numberUtils.ts";

export const toCustomerOrderProfitabilityDisplayAmount = (
	lineKey: CustomerOrderProfitabilityLineKey,
	value: number,
): number => {
	return isCustomerOrderProfitabilityCostLineKey(lineKey) ? -value : value;
};

export const fromCustomerOrderProfitabilityDisplayAmount = (
	lineKey: CustomerOrderProfitabilityLineKey,
	value: number,
): number => {
	return isCustomerOrderProfitabilityCostLineKey(lineKey) ? Math.abs(value) : value;
};

export const formatCustomerOrderProfitabilityValue = (
	lineKey: CustomerOrderProfitabilityLineKey,
	value: number,
	domesticCurrencyCode: string,
): string => {
	if (lineKey === "MARGIN_PERCENT") {
		return i18n.t("percent_value", { val: value });
	}

	return formatMoneyWithCurrency(value, domesticCurrencyCode);
};

export const formatCustomerOrderProfitabilityComparisonAmount = (
	lineKey: CustomerOrderProfitabilityLineKey,
	value: number,
	domesticCurrencyCode: string,
): string => {
	const formattedValue = formatCustomerOrderProfitabilityValue(lineKey, value, domesticCurrencyCode);

	return value > 0 ? `+${formattedValue}` : formattedValue;
};

export const isGoodCustomerOrderProfitabilityComparisonDisplayAmount = (value: number): boolean => {
	return value >= 0;
};

export const isCustomerOrderProfitabilityCostLineKey = (
	lineKey: CustomerOrderProfitabilityLineKey,
): boolean => {
	switch (lineKey) {
		case "CUSTOMER_ORDER_LINE_COSTS":
		case "CUSTOMER_ORDER_LINE_COST_WAREHOUSE":
		case "CUSTOMER_ORDER_LINE_COST_PURCHASE_TRANSIT":
		case "CUSTOMER_ORDER_LINE_COST_PURCHASE_DIRECT":
		case "CUSTOMER_ORDER_LINE_COST_MANUFACTURE":
		case "CUSTOMER_ORDER_LINE_COST_NO_ACQUISITION":
		case "CUSTOMER_ORDER_LINE_COST_SPLIT_BOM":
		case "PROJECT_MATERIAL_COSTS":
		case "PROJECT_MATERIAL_COST_WAREHOUSE":
		case "PROJECT_MATERIAL_COST_PURCHASE_TRANSIT":
		case "PROJECT_MATERIAL_COST_PURCHASE_DIRECT":
		case "PROJECT_MATERIAL_COST_MANUFACTURE":
		case "PROJECT_MATERIAL_COST_NO_ACQUISITION":
		case "PROJECT_MATERIAL_COST_SPLIT_BOM":
		case "OTHER_COSTS":
		case "PROJECT_COST_EVENTS":
		case "CUSTOMER_ORDER_COST_EVENTS":
		case "RECLAMATION_COSTS":
		case "TOTAL_COSTS":
			return true;
		case "REVENUE":
		case "MARGIN":
		case "MARGIN_PERCENT":
			return false;
	}
};
